module.exports = __webpack_public_path__ + "static/img/MT.5bcfa2ed.png";